var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ProviderId } from "@firebase/auth";
import { Icon, Popup } from "semantic-ui-react";
const PROVIDER_ICONS = {
    [ProviderId.FACEBOOK]: "facebook square",
    [ProviderId.GITHUB]: "github",
    [ProviderId.GOOGLE]: "google",
    [ProviderId.PASSWORD]: "mail",
    [ProviderId.PHONE]: "phone",
    [ProviderId.TWITTER]: "twitter",
    "apple.com": "apple",
};
export function ProviderIcon(_a) {
    var _b;
    var { providerId } = _a, iconProps = __rest(_a, ["providerId"]);
    return _jsx(Icon, Object.assign({}, iconProps, { name: (_b = PROVIDER_ICONS[providerId]) !== null && _b !== void 0 ? _b : "openid" }));
}
export function ProviderIcons({ user }) {
    if (!user) {
        return null;
    }
    return (_jsx(_Fragment, { children: user.providerData.map((provider, i) => (_jsx(Popup, { flowing: true, trigger: _jsx(ProviderIcon, { providerId: provider.providerId, size: "large", color: "grey" }), content: _jsx(_Fragment, { children: provider.providerId }) }, provider.providerId + i))) }));
}
